import { useMemo } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import ArgonButton from "components/ArgonButton";
import EditIcon from "@mui/icons-material/Edit";
import { Chip } from "@mui/material";

const PaymentDetailsTableData = (tutor) => {
  const columns = [
    { name: "sno", align: "center" },
    { name: "Payment Mode", align: "left" },
    { name: "Bank Name", align: "left" },
    { name: "Account Number", align: "left" },
    { name: "IFSC Code", align: "left" },
    { name: "Account Holder", align: "left" },
    { name: "UPI ID", align: "left" },
  ];

  const rows = useMemo(() => {
    if (!tutor) return [];

    const paymentDetails = tutor.paymentDetails;

    if (paymentDetails && paymentDetails.mode) {
      return [
        {
          sno: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              1
            </ArgonTypography>
          ),
          "Payment Mode": (
            <Chip
              label={paymentDetails.mode}
              color={paymentDetails.mode === "BANK" ? "primary" : "success"}
              size="small"
              sx={{ fontWeight: "medium" }}
            />
          ),
          "Bank Name": (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {paymentDetails.mode === "BANK" ? paymentDetails.bankName || "N/A" : "-"}
            </ArgonTypography>
          ),
          "Account Number": (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {paymentDetails.mode === "BANK" ? paymentDetails.accountNumber || "N/A" : "-"}
            </ArgonTypography>
          ),
          "IFSC Code": (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {paymentDetails.mode === "BANK" ? paymentDetails.ifscCode || "N/A" : "-"}
            </ArgonTypography>
          ),
          "Account Holder": (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {paymentDetails.mode === "BANK" ? paymentDetails.accountHolderName || "N/A" : "-"}
            </ArgonTypography>
          ),
          "UPI ID": (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {paymentDetails.mode === "UPI" ? paymentDetails.upiId || "N/A" : "-"}
            </ArgonTypography>
          ),
        },
      ];
    }
    return [];
  }, [tutor]);

  return { columns, rows };
};

export default PaymentDetailsTableData;
